/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
  // WebPAge Policy
  {
    path: "/policy",
    component: () => import("../views/PolicyView.vue"),
  },

  // BBG
  // https://blockblast-bd3c9.web.app/bbg
  {
    path: "/bbg",
    component: () => import("../views/BBG_HomeView.vue"),
  },
  // https://blockblast-bd3c9.web.app/bbg_policy
  {
    path: "/bbg_policy",
    component: () => import("../views/BBG_PolicyView.vue"),
  },

  // JMG
  // https://blockblast-bd3c9.web.app/jmg
  {
    path: "/jmg",
    component: () => import("../views/JMG_HomeView.vue"),
  },
  // https://blockblast-bd3c9.web.app/jmg_policy
  {
    path: "/jmg_policy",
    component: () => import("../views/JMG_PolicyView.vue"),
  },

  // JSMG
  // https://blockblast-bd3c9.web.app/jsmg
  {
    path: "/jsmg",
    component: () => import("../views/JSMG_HomeView.vue"),
  },
  // https://blockblast-bd3c9.web.app/jsmg_policy
  {
    path: "/jsmg_policy",
    component: () => import("../views/JSMG_PolicyView.vue"),
  },

  // JAG
  // https://blockblast-bd3c9.web.app/jag
  {
    path: "/jag",
    component: () => import("../views/JAG_HomeView.vue"),
  },
  // https://blockblast-bd3c9.web.app/jag_policy
  {
    path: "/jag_policy",
    component: () => import("../views/JAG_PolicyView.vue"),
  },

  // MMG
  // https://blockblast-bd3c9.web.app/mg
  {
    path: "/mg",
    component: () => import("../views/MMG/MMG_HomeView.vue"),
  },
  // https://blockblast-bd3c9.web.app/mg_policy
  {
    path: "/mg_policy",
    component: () => import("../views/MMG/MMG_PolicyView.vue"),
  },

  // JDOKI
  // https://blockblast-bd3c9.web.app/doki
  {
    path: "/doki",
    component: () => import("../views/DOKI/DOKI_HomeView.vue"),
  },
  // https://blockblast-bd3c9.web.app/doki_policy
  {
    path: "/doki_policy",
    component: () => import("../views/DOKI/DOKI_PolicyView.vue"),
  },

  //
  {
    path: "/test",
    component: () => import("../views/TestView.vue"),
  },

  // 삭제예정 - 2026-01-01
  // {
  //   path: "/privacy_policy",
  //   component: () => import("../views/BBG_PolicyView.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
